import { AdminPage } from "../_shared"; export default function Page(){return <AdminPage title="Ad Landing Pages" />;}
